import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const BillingDetailsWrapper = styled.div`
  margin: 20px;
  ${responsive.MOBILE`
    margin: 16px 8px;
  `}
  .MuiStack-root {
    padding: 0;
  }

  .billing-details-grid {
    display: flex;
    margin: 40px 0px;
    > * {
      flex: 1 1;
    }
    ${responsive.MOBILE`
    flex-direction: column;
    margin: 16px 0;
      > * {
        flex: 0 0 auto;
        width: 100%;
      }
    `}
  }
`;
